module.exports = __webpack_public_path__ + "static/media/life-placeholder.f6bd691d.webp";